import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=31932043&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=31932043&prod&lang=sass"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=31932043&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31932043",
  null
  
)

export default component.exports